import React from 'react';
// components
import Title from '../../components/Title';

// assets
import BankLogo from '../../assets/img/BankLogo.png';
import Button from '../../components/Button';
import { Img, ImgDiv, WrapperDiv } from './errorStyled';

function ErrorSession() {

  const handleRetry = () => {
    window.location.reload();
  };

  return (
    <WrapperDiv>
      <Title>
        La sesión ha caducado. Vuelva a ingresar. 
      </Title>
      <ImgDiv>
        <Img src={BankLogo} />
      </ImgDiv>
      <Button filled grid="buttons" onClick={handleRetry}>
        Ir a inicio
      </Button>
    </WrapperDiv>
  );
}

export default ErrorSession;
